var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import * as React from 'react';
class SceneComponent extends React.PureComponent {
    render() {
        const _a = this.props, { component } = _a, rest = __rest(_a, ["component"]);
        return React.createElement(component, rest);
    }
}
export default function SceneMap(scenes) {
    return ({ route, jumpTo, position }) => (React.createElement(SceneComponent, { key: route.key, component: scenes[route.key], route: route, jumpTo: jumpTo, position: position }));
}
